import {createSlice} from "@reduxjs/toolkit";

export interface IPricesUnlockedState {
    /**
     * Flag indicating that prices have been manually unlocked
     * (e.g., after sending a lead form, even for unauthenticated users)
     */
    isUnlocked: boolean;
}

const initialState: IPricesUnlockedState = {
    isUnlocked: false
};

export const pricesUnlockedSlice = createSlice({
    name: "pricesUnlocked",
    initialState,
    reducers: {
        unlockPrices: (state) => {
            state.isUnlocked = true;
        },
        lockPrices: (state) => {
            state.isUnlocked = false;
        }
    }
});

export const {unlockPrices, lockPrices} = pricesUnlockedSlice.actions;
